<div class="nav-item" [class.active]="isActive">
  <div class="button-container">
    <div class="notification-badge body-xs semibold" *ngIf="count && count > 0" role="status">
      {{ count > 9 ? '9+' : count }}
    </div>
    <div class="icon-box">
      <ptl-icon [icon]="icon" [size]="size"></ptl-icon>
    </div>
  </div>
  <div class="body-s bold text" *ngIf="text">{{ text }}</div>
</div>
